import style from './style.module.scss'

export const ExperimentItem = ({ item }: { item: any }) => {
  return (
    <li className={style.experiment_item}>
      <span>{item.name}</span>
      <span>{item.status}</span>
      <span>{item.startDate}</span>
      <span>{item.endDate}</span>
      <span>{item.goals}</span>
      <span>{item.currentGoals}</span>

      <span>
        <img src="/src/assets/img/icons/dots.svg" alt="dots" />
      </span>
    </li>
  )
}
